import { HHMMToMs } from "../../helpers/helpers"
import { OnsiteTimelineBrick } from "../onsite.data"

export const sortOnsiteTimelineBrick = (a: OnsiteTimelineBrick, b: OnsiteTimelineBrick, order: string[] = null) => { // order could be program order could be schedule order

  const aStart = HHMMToMs(a.start || a.time)
  const bStart = HHMMToMs(b.start || b.time)
  // console.log({ aTime: a.start || a.time, bTime: b.start || b.time, aStart, bStart, aType: a.type, bType: b.type, a, b})

  // obviously go by time when possible
  if (aStart < bStart) return -1
  else if (bStart < aStart) return 1
  
  // times are equal for all this logic
  const scheduleA = a.scheduleId
  const scheduleB = b.scheduleId
  
  /* otherwise, order goes by
  1) Clear
  2) Access
  3) Activity
  4) Session

  Within these (so if there are two clears) order goes by program order.
  */

  if (a.type === 'clear' && b.type !== 'clear') return -1
  if (b.type === 'clear' && a.type !== 'clear') return 1

  if (a.type === 'access' && b.type !== 'access') return -1
  if (b.type === 'access' && a.type !== 'access') return 1
  
  if (a.type === 'activity' && b.type !== 'activity') return -1
  if (b.type === 'activity' && a.type !== 'activity') return 1

  if (scheduleA && scheduleB && scheduleA !== scheduleB && !!order) {
    const indexA = order.findIndex(id => id === scheduleA)
    const indexB = order.findIndex(id => id === scheduleB)
    // console.log({ scheduleA, indexA, scheduleB, indexB })
    return indexA - indexB
  }

  if (a.type === 'clear') return -1
  if (b.type === 'clear') return 1

  if (a.type === 'access') return -1
  if (b.type === 'access') return 1

  if (a.type === 'activity') return -1
  if (b.type === 'activity') return 1
  
  if (a.type === 'session' && b.type === 'session') return a.scheduleOrder - b.scheduleOrder
  return -1 // default is to keep same order
}